import { render, staticRenderFns } from "./Interaction.vue?vue&type=template&id=156790d2"
import script from "./Interaction.vue?vue&type=script&lang=js"
export * from "./Interaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports